<template>
	<div id="devices">
		<Header :title="strings.title">{{ strings.header }}</Header>

		<v-card class="mx-auto">
			<device-list
				:fn-click-item="pairDevice"
				:fn-filter-items="filterVisible"
				disable
			/>
		</v-card>

		<!-- Dialogs -->
		<dialog-confirm-dialog ref="confirmDialog" :body="strings.confirm" />
		<PairingWizard
			ref="pairDialog"
			:device="pairingDevice"
			@close="pairingDevice = null"
		/>

		<!-- Dialogs - triggered by speed dial -->
		<device-dialog-add-device ref="addDeviceDialog" :rooms="rooms" />
		<device-dialog-add-room ref="addRoomDialog" />

		<!-- Fab Buttons -->
		<NextFab :value="allPaired" :next="nextFn">
			<template #icon-alt>
				<RadialProgress />
			</template>

			<template #tooltip>{{ fabText }}</template>
			<template #tooltip-alt>{{ strings.altComplete }}</template>
		</NextFab>

		<device-speed-dial
			v-model="hideInstalled"
			class="speed-dial"
			fixed
			@action:addDevice="addDevice"
			@action:addRoom="addRoom"
		/>
	</div>
</template>

<style lang="scss" scoped>
#devices {
	margin-bottom: 68px;

	.speed-dial {
		bottom: $second-fab-bottom;
	}
}
</style>

<script>
import { filter } from "lodash";
import { mapGetters, mapActions } from "vuex";

import strings from "@/utils/strings";

import Header from "../../shared/Header";
import NextFab from "../../shared/NextFab";

import PairingWizard from "./PairingWizard";
import RadialProgress from "./RadialProgress";

export default {
	components: {
		Header,
		NextFab,
		PairingWizard,

		RadialProgress,
	},

	props: ["nextFn"],

	data: function() {
		return {
			pairingDevice: null,
			hideInstalled: false,
		};
	},

	computed: {
		...mapGetters({
			isPaired: "devices/isPaired",
			allPaired: "devices/allPaired",

			roomsLive: "controller/nodes/rooms",
			roomsLocal: "devices/rooms",
		}),

		strings() {
			return strings.devices;
		},

		isLocal() {
			return !!this.$store.state.controller.local;
		},

		rooms() {
			return this.isLocal ? this.roomsLocal : this.roomsLive;
		},

		fabText() {
			return this.$store.getters["install/requiresProvisioning"]
				? this.strings.complete
				: this.strings.completeSkipToTest;
		},
	},

	watch: {
		async pairingDevice(val) {
			if (!val) {
				// exiting pairing, reload devices
				await this.$store.dispatch("devices/load");
			}
		},
	},

	methods: {
		...mapActions({
			add: "controller/nodes/add",
		}),

		filterVisible(devices) {
			if (!this.hideInstalled) return devices;

			return filter(devices, device => {
				return !this.isPaired(device.guid);
			});
		},

		async pairDevice(item) {
			if (item && this.isPaired(item.guid)) {
				let confirmed = await this.$refs.confirmDialog.pop();
				if (!confirmed) {
					return;
				}
			}

			this.pairingDevice = item;
		},

		addDevice() {
			return this.$refs.addDeviceDialog.pop(this.add);
		},

		addRoom() {
			return this.$refs.addRoomDialog.pop(this.add);
		},
	},
};
</script>
